import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth, getAuthFromCookie } from "./views/auth/auth";

interface Props {
  children: React.ReactNode;
}

export const ProtectedRoute = ({
  children,
}: Props) => {
  const hasStoredAuth = Boolean(getAuthFromCookie());
  const [loading, setLoading] = useState(!hasStoredAuth);
  const [authenticated, setAuthenticated] =
    useState(hasStoredAuth);

  useEffect(() => {
    const checkAuth = async () => {
      const result =
        await auth.isAuthenticated();

      setAuthenticated(result);
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return null;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};